import React from "react";
import {Modal, ModalFooter, Button, ModalHeader, ModalBody} from "reactstrap";
import i18n from "utils/i18n";
import ButtonLoader from "../components/ButtonLoader/ButtonLoader";

const UnsubcribeModal = ({ setIsOpen, isOpen, error, onSubmit, isLoading }) => {
  const retryModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Modal
      isOpen={isOpen}
      zIndex={9999}
      size="lg"
    >
      <div>
        <ModalHeader toggle={() => retryModal()}>
          {i18n("dashboard.components.modal.unsubscribeRequest")}
        </ModalHeader>

        <ModalBody>
          <div>
            <p>{i18n("dashboard.components.modal.unsubscribeText")}</p>
          </div>
          <hr className="Unsubcribe-modal-hr"></hr>
        </ModalBody>

        <ModalFooter>
          <Button type="submit" onClick={() => retryModal()}>
            {i18n("dashboard.components.modal.btnClose")}
          </Button>
          <ButtonLoader
            className="Unsubcribe-modal-btn-send"
            text={i18n("dashboard.components.modal.btnSend")}
            onClick={onSubmit}
            isLoading={isLoading}
          />
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default UnsubcribeModal;
